interface Props {
  color?: string
  width?: number
  height?: number
}

export const PlusIcon = ({ color = '#6F6F6F', width = 19, height = 19 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M9.5 0.5V18.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M0.5 9.5H18.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
